import { InspectorControlsGeneral } from '@components/inspector-tabs';
import Visibility from '@components/visibility';
import Label from '@components/block-label';
import Select from 'react-select';
import { getInnerBlockTemplate } from '@helpers/utils.js';

const {
  i18n: { __ },
  data: { useSelect, useDispatch },
  components: { PanelBody, ToggleControl, RadioControl, RangeControl },
  blocks: { createBlock },
} = wp;

const InspectorGeneral = ({
  attributes,
  setAttributes,
  defaultPostTaxonomyOptions,
  getRelatedPosts,
  clientId,
}) => {
  const {
    numberOfPosts,
    selection,
    orderBy,
    order,
    postTaxonomies,
    isBackgroundImage,
    anchorAppearance,
    blockVisibility,
    label,
  } = attributes;

  const { replaceInnerBlocks } = useDispatch('core/block-editor');

  const { innerBlocks, currentPostId, currentPostType } = useSelect(
    (select) => ({
      innerBlocks: select('core/block-editor').getBlocks(clientId),
      currentPostId: select('core/editor').getCurrentPostId(),
      currentPostType: select('core/editor').getCurrentPostType(),
    }),
  );

  // Image Appearance onselect function
  const onSelectImageAppearance = (newVal) => {
    setAttributes({ isBackgroundImage: newVal });
    reRenderBlockWithDisplayItem(newVal, anchorAppearance);
  };

  //Anchor Element Appearance onselect function
  const onSelectAnchorAppearance = (newVal) => {
    setAttributes({ anchorAppearance: newVal });
    reRenderBlockWithDisplayItem(isBackgroundImage, newVal);
  };

  const reRenderBlockWithDisplayItem = (
    imageAppearanceValue = isBackgroundImage,
    anchorAppearanceValue = anchorAppearance,
  ) => {
    const updatedInnerBlocks = [];
    innerBlocks.forEach((innerBlock) => {
      const template = getInnerBlockTemplate(innerBlock, imageAppearanceValue);

      updatedInnerBlocks.push(
        createBlock('b3rg/single-post', {
          ...innerBlock.attributes,
          isBackgroundImage: imageAppearanceValue,
          anchorAppearance: anchorAppearanceValue,
          template,
        }),
      );
    });
    replaceInnerBlocks(clientId, updatedInnerBlocks, false);
  };

  return (
    <InspectorControlsGeneral>
      <Label {...{ label, setAttributes }} />
      <Visibility {...{ blockVisibility, setAttributes }} />
      <PanelBody title={__('Related Posts Settings', 'b3rg')}>
        <RadioControl
          label={__('Related Posts Selection Mode', 'b3rg')}
          options={[
            { label: 'Auto', value: 'auto' },
            { label: 'Manual', value: 'manual' },
          ]}
          selected={selection}
          onChange={(selectionVal) => {
            setAttributes({ selection: selectionVal });
            if (selectionVal === 'auto') {
              getRelatedPosts({
                numberOfPosts,
                orderBy,
                currentPostId,
                order,
                postTaxonomies,
                selectionVal,
              });
            }
          }}
        />

        {selection === 'auto' && (
          <>
            {currentPostType !== 'page' && (
              <div className="components-base-control">
                <label
                  htmlFor="post-taxonomies"
                  className="post-taxonomy-label"
                >
                  {__('Post Taxonomies', 'b3rg')}
                </label>
                <Select
                  isMulti
                  name="post_taxonomies"
                  options={defaultPostTaxonomyOptions}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  value={postTaxonomies}
                  onChange={(postTaxonomiesVal) => {
                    setAttributes({ postTaxonomies: postTaxonomiesVal });
                    getRelatedPosts({
                      numberOfPosts,
                      orderBy,
                      currentPostId,
                      order,
                      postTaxonomies: postTaxonomiesVal,
                      selection,
                    });
                  }}
                />
              </div>
            )}
            <RangeControl
              label={__('Number of posts', 'b3rg')}
              value={numberOfPosts}
              onChange={(numberOfPostsVal) => {
                setAttributes({ numberOfPosts: numberOfPostsVal });
                getRelatedPosts({
                  numberOfPosts: numberOfPostsVal,
                  orderBy,
                  currentPostId,
                  order,
                  postTaxonomies,
                  selection,
                });
              }}
              min={1}
              max={20}
            />
            <RadioControl
              label={__('Order by', 'b3rg')}
              options={[
                { label: 'Relevance', value: 'relevance' },
                { label: 'By Date', value: 'date' },
                { label: 'By Title', value: 'title' },
              ]}
              selected={orderBy}
              onChange={(orderBy) => {
                setAttributes({ orderBy });
                getRelatedPosts({
                  numberOfPosts,
                  orderBy,
                  currentPostId,
                  order,
                  postTaxonomies,
                  selection,
                });
              }}
            />
            {orderBy !== 'relevance' && (
              <RadioControl
                label={__('Order', 'b3rg')}
                options={[
                  { label: 'Ascending', value: 'ASC' },
                  { label: 'Descending', value: 'DESC' },
                ]}
                selected={order}
                onChange={(order) => {
                  setAttributes({ order });
                  getRelatedPosts({
                    numberOfPosts,
                    orderBy,
                    currentPostId,
                    order,
                    postTaxonomies,
                    selection,
                  });
                }}
              />
            )}
            <RadioControl
              label={__('Anchor Element Appearance', 'berg')}
              options={[
                { label: 'Wrap All', value: 'full' },
                { label: 'Inner Link', value: 'inner' },
              ]}
              selected={anchorAppearance}
              onChange={onSelectAnchorAppearance}
            />
            <ToggleControl
              label="Set Image As a Background"
              checked={isBackgroundImage}
              onChange={onSelectImageAppearance}
            />
          </>
        )}
      </PanelBody>
    </InspectorControlsGeneral>
  );
};

export default InspectorGeneral;
